import { useState } from "react";
import { ArrowLeft, Edit, Trash2 } from "lucide-react";
import CustomSearch from "../../../components/common/CustomSearch";
import CustomButton from "../../../components/common/CustomButton/CustomButton";
import CustomSwitch from "../../../components/common/CustomSwitch";
import AddCategoryForm from "./AddCategorieForm";
import AddSubCategoryForm from "./AddSubcategoryForm";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { deleteCategory } from "../../../Services/categoryService";
import CustomDialog from "../../../components/common/CustomDialog";
import { deleteSubCategory } from "../../../Services/categoryService";
import {updateCategoryStatus,updateSubcategoryStatus} from "../../../Services/categoryService";
import { toast } from "react-toastify";
import ServerPaginationDataGridWithReactQuery from "../../../components/common/CustomDataGrid/ServerPaginationDataGridWithReactQuery";
import { useRef } from "react";
import { fetchActiveCategories } from "../../../Services/categoryService";
import ServerPaginationDataGrid from "../../../components/common/CustomDataGrid/ServerPaginationDataGrid";
import { getAllCategoriesWithProductCountUrl, getAllSubCategoriesUrl } from "../../../utils/urls";
export default function ProductsPage() {
  
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [activeTab, setActiveTab] = useState("category");
  const [showAddCategory, setShowAddCategory] = useState(false);
  const [showAddSubCategory, setShowAddSubCategory] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  // const [categoryData, setCategoryData] = useState(categories);
  const [categoryId, setCategoryId] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [subCategoryId, setSubCategoryId] = useState(null);
  const [Load, setLoad] = useState(false);
  const datagriduseRef = useRef(null);

  // Category columns
  const categoryColumns = [
    {
      field: "serial",
      headerName: "#",
      width: 80,
      renderCell: (row) =>{        
        return (
          <span className="text-gray-600">{row?.rowIndex}</span>
        )
      },
    },
    { 
      field: "category_title", 
      headerName: "Category Name", 
      width: "270px",
      renderCell: (row) => (
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 flex-shrink-0">
            {row.logo_url ? (
              <img 
                src={row.logo_url} 
                alt={row.category_title} 
                className="w-full h-full object-contain rounded-md"
              />
            ) : (
              <div className="w-full h-full bg-gray-100 rounded-md flex items-center justify-center">
                <span className="text-gray-400 text-xs">No Logo</span>
              </div>
            )}
          </div>
          <span>{row.category_title}</span>
        </div>
      )
    },
    {
      field: "sub_category_count",
      headerName: "Sub Categories",
      width: "200px",
    },
    { field: "product_count", headerName: "Products", width: "200px" },
    {
      field: "is_active",
      headerName: "Status",
      width: "230px",
      renderCell: (row) => {
        return (
          <div className="flex items-center justify-start">
            <CustomSwitch
              value={row.is_active} // Access status directly
              name={`category-status-${row.category_id}`}
              onChange={() =>
                handleStatusChange(row.category_id, row.is_active, "category")
              }
            />
            <span className="ml-2">
              {row.is_active ? "Active" : "Inactive"}
            </span>
          </div>
        );
      },
    },
    {
      field: "actions",
      headerName: "Action",
      width: "100px",
      renderCell: (params) => (
        <div className="flex space-x-2">
          <button
            onClick={() => handleEdit(params)}
            className="text-blue-500 hover:text-blue-700"
          >
            <Edit size={18} />
          </button>
          <button
            onClick={() => {
              handleOpenCategoryDialog(params);
            }}
            className="text-red-500 hover:text-red-700"
          >
            <Trash2 size={18} />
          </button>
        </div>
      ),
    },
  ];

  // Sub Category columns
  const subCategoryColumns = [
    { field: "serial", headerName: "#", width: "80px",
      renderCell: (row) =>{        
        return (
          <span className="text-gray-600">{row?.rowIndex}</span>
        )
      },
    },
    { 
      field: "title", 
      headerName: "Sub Category", 
      width: "250px",
      renderCell: (row) => (
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 flex-shrink-0">
            {row.logo_url ? (
              <img 
                src={row.logo_url} 
                alt={row.title} 
                className="w-full h-full object-contain rounded-md"
              />
            ) : (
              <div className="w-full h-full bg-gray-100 rounded-md flex items-center justify-center">
                <span className="text-gray-400 text-xs">No Logo</span>
              </div>
            )}
          </div>
          <span>{row.title}</span>
        </div>
      )
    },
    {
      field: "category",
      headerName: "Category",
      width: "250px",
      renderCell: (row) => row?.category?.title, // Accessing the 'title' property of the 'category' object
    },
    {
      field: "is_active",
      headerName: "Status",
      width: "250px",
      renderCell: (row) => (
        <div className="flex items-center">
          <CustomSwitch
            value={row.is_active}
            name={`subcategory-status-${row.sub_category_id}`}
            onChange={() =>
              handleStatusChange(
                row.sub_category_id,
                row.is_active,
                "subcategory"
              )
            }
          />
          <span className="ml-2">{row.is_active ? "Active" : "Inactive"}</span>
        </div>
      ),
    },
    {
      field: "actions",
      headerName: "Action",
      width: "150px",
      renderCell: (row) => (
        <div className="flex space-x-2">
          <button
            onClick={() => handleEditSubCategory(row)}
            className="text-blue-500 hover:text-blue-700"
          >
            <Edit size={18} />
          </button>
          <button
            onClick={() => handleOpenSubCategoryDialog(row)}
            className="text-red-500 hover:text-red-700"
          >
            <Trash2 size={18} />
          </button>
        </div>
      ),
    },
  ];

  const handleEdit = (rowData) => {
    console.log("Editing category", rowData);
  setSelectedCategory(rowData);
  setShowAddCategory(true);
  };

  const handleEditSubCategory = (rowData) => {
  
    console.log("Updating subcategory", rowData);

    
    setSelectedSubCategory(rowData);

    
    setShowAddSubCategory(true);
  };

  const handleSearch = (term) => {
    setSearchTerm(term.toLowerCase());
  };
  const handleCategorySave = async () => {
    

    try {
      datagriduseRef.current?.restartComponent()
     
    } catch (error) {
      console.error("Failed to fetch updated data:", error);
    } finally {
     
      setShowAddCategory(false);
      // Close form after saving
      setSelectedCategory(null);
    }
  };
  const handleSubCategorySave = async () => {
    
    try {
      datagriduseRef.current?.restartComponent()
      
    } catch (error) {
      console.error("Failed to fetch updated data:", error);
    } finally {
      
      setShowAddSubCategory(false);
      setSelectedSubCategory(null);
      // Close form after saving
    }
  };

  if (showAddCategory) {
    return (
      <AddCategoryForm
        onCancel={() => {
          setSelectedCategory(null); // Reset only if nothing changed
          setShowAddCategory(false);
        }}
        onSave={handleCategorySave}
        initialValues={selectedCategory}
      />
    );
  }

  if (showAddSubCategory) {
    return (
      <AddSubCategoryForm
        onCancel={() => {
          setSelectedSubCategory(null); // Reset only if nothing changed
          setShowAddSubCategory(false);
        }}
        onSave={handleSubCategorySave}
        initialValues={selectedSubCategory}
      />
    );
  }
  const handleOpenCategoryDialog = (row) => {
    setCategoryId(row.category_id);
    setOpen(true);
  };

  const handleOpenSubCategoryDialog = (row) => {
    setSubCategoryId(row.sub_category_id);
    setOpen(true);
  };

  const handleDeleteCategory = async (categoryId) => {
    try {
      await deleteCategory(categoryId);
      toast.success("Category deleted successfully!");
      datagriduseRef.current.restartComponent();
    } catch (error) {
      toast.error("Failed to delete category.");
    }
  };
  const handleStatusChange = (id, isActive, type) => {
    setSelectedCategory({ id, isActive, type });
    setOpenStatus(true); // Open confirmation dialog
  };

  const handleDeleteSubCategory = async (subCategoryId) => {
    try {
      await deleteSubCategory(subCategoryId);
      toast.success("Subcategory deleted successfully!");
      datagriduseRef.current.restartComponent();
    } catch (error) {
      toast.error("Failed to delete subcategory. Please try again.");
    }
  };
  const confirmStatusChange = async () => {
    if (!selectedCategory) return;
    setLoad(true);

    try {
      if (selectedCategory.type === "subcategory") {
        await updateSubcategoryStatus(
          selectedCategory.id,
          !selectedCategory.isActive
        );
   
      } else {
        await updateCategoryStatus(
          selectedCategory.id,
          !selectedCategory.isActive
        );
       
      }
      // Re-fetch categories and subcategories after status change
      toast.success("Status updated successfully!");
      datagriduseRef.current?.restartComponent();

      
    } catch (error) {
      console.error("Failed to update status:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoad(false);
      setOpenStatus(false);
    }
  };

  return (
    <div className="">
      {/* Header */}
      <div className="gap-4 mb-2 flex items-center">
        <button
          className="p-2 border rounded-md"
          onClick={() => {
            navigate("/configurations");
          }}
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
        <h1 className="text-2xl font-semibold text-blue-900">All Products</h1>
      </div>

      {/* Tabs */}
      <div className="border-b">
        <div className="flex">
          <button
            className={`px-6 py-3 font-medium ${
              activeTab === "category"
                ? "text-blue-500 border-b-2 border-blue-500"
                : "text-gray-600"
            }`}
            onClick={() => setActiveTab("category")}
          >
            Category
          </button>
          <button
            className={`px-6 py-3 font-medium ${
              activeTab === "subcategory"
                ? "text-blue-500 border-b-2 border-blue-500"
                : "text-gray-600"
            }`}
            onClick={() => setActiveTab("subcategory")}
          >
            Sub Category
            
          </button>
        </div>
      </div>

      {/* Search and Add Button */}
      <div className="p-4 flex justify-between items-center">
        <div className="w-full ">
          <CustomSearch
            placeholder="Search here..."
            onChange={handleSearch}
            className="w-full bg-white"
          />
        </div>
        <CustomButton
          label={
            activeTab === "category"
              ? "Add New Category"
              : "Add New Subcategory"
          }
          variant="contained"
          onClick={() =>
            activeTab === "category"
              ? setShowAddCategory(true)
              : setShowAddSubCategory(true)
          }
        />
      </div>

      {/* Data Grid */}
      <div className=" rounded-lg">
        {activeTab === "category" ? (
         
          <ServerPaginationDataGrid
            url={getAllCategoriesWithProductCountUrl}
            requestParameter={{ search: searchTerm }}
            // search={searchTerm}
            columns={categoryColumns}
            isServerPagination={true}
            keyId={"categoryId"}
            dataMapper={(list) =>{
                // console.log("list", list);
                
                const mappedList =  list?.data?.map((item, index) => ({
                  ...item
                }))
                return {data: mappedList}
            }
            }
            
            
            ref={datagriduseRef}
            // height={"calc(100vh - 350px)"}
          />
        ) : (
          
          <ServerPaginationDataGrid
            url={getAllSubCategoriesUrl}
            requestParameter={{ search: "" }}
            search={searchTerm}
            columns={subCategoryColumns}
            isServerPagination={true}
            keyId={"subCategoryId"}
            dataMapper={(list) =>{
              const mappedList =  list?.data?.map((item, index) => ({
                  ...item
                }))
                return {data: mappedList}
            }}
            ref={datagriduseRef}
            
            // height={"calc(100vh - 350px)"}
          />
        )}
      </div>
      <CustomDialog
        open={open}
        setOpen={setOpen}
        title="Are You Sure?"
        titleClassName="text-center"
      >
        <div className="w-[400px] text-center">
          <p className="text-gray-600 text-left border-b">
            {activeTab === "category"
              ? "Are you sure you want to delete this category? This action cannot be undone."
              : "Are you sure you want to delete this subcategory? This action cannot be undone."}
          </p>
          <div className="flex justify-between gap-3 mt-4">
            <button
              className="py-2 px-4 bg-gray-200 font-semibold text-base w-[170px] rounded-md"
              onClick={() => setOpen(false)}
            >
              Cancel
            </button>

            <button
              className="py-2 px-4 bg-blue-500 w-[170px] font-semibold text-base text-white rounded-md"
              onClick={() => {
                if (activeTab === "category") {
                  handleDeleteCategory(categoryId);
                } else {
                  handleDeleteSubCategory(subCategoryId);
                }
                setOpen(false);
              }}
            >
              Delete
            </button>
          </div>
        </div>
      </CustomDialog>
      <CustomDialog
        open={openStatus}
        setOpen={setOpenStatus}
        title="Are You Sure?"
        titleClassName="text-center"
      >
        <div className="w-[400px] text-center">
          <p className="text-gray-600 text-left border-b">
            {selectedCategory?.type === "category"
              ? "Are you sure you want to change the status of this category?"
              : "Are you sure you want to change the status of this subcategory?"}
          </p>
          <div className="flex justify-between gap-3 mt-4">
            <button
              className="py-2 px-4 bg-gray-200 font-semibold text-base w-[170px] rounded-md"
              onClick={() => setOpenStatus(false)}
            >
              Cancel
            </button>

            <button
              className="py-2 px-4 bg-blue-500 w-[170px] font-semibold text-base text-white rounded-md"
              onClick={confirmStatusChange}
              disabled={Load}
            >
              {Load ? "Updating..." : "Confirm"}
            </button>
          </div>
        </div>
      </CustomDialog>
    </div>
  );
}
